import React from 'react';
import { useTranslation } from "react-i18next";
import { Box, Table, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react"

const LinkedSuppliersToItemTable = ({data}) => {
    const { t } = useTranslation();

    return (
    <Box
    bg="light" overflow="auto"
    borderRadius={4} boxShadow="0rem 0.3125rem 0.3125rem 0rem rgba(82, 63, 105, 0.05)"
  >
    <Table>
      <Thead>
        <Tr>
          <Th>#</Th>
          <Th>{t("pages.branches.name")}</Th>
          <Th>{t("pages.suppliers.inventory_item_ref")}</Th>
          <Th>{t("pages.suppliers.StorageUnit")}</Th>
        </Tr>
      </Thead>
      <Tbody>
        {data.map((el, index) => (
          <Tr key={el.ItemsSuppliersId}>
            <Td>{index + 1}</Td>
            <Td>{el?.InventoryItem[0].InventoryItemNameEng}</Td>
            <Td>{el?.InventoryItem[0].InventoryItemRef}</Td>
            <Td>{el?.InventoryItem[0].StorageUnit}</Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  </Box>
  );
}

export default LinkedSuppliersToItemTable;
